exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-hidden[data-v-6b4b9b10]{display:block;width:0;height:0;margin:0;padding:0;overflow:hidden}", ""]);

// exports
